import React, { useContext, useState, useEffect } from 'react'
import {
  ButtonsDiv,
  CloseDiv,
  CloseImg,
  Container,
  CreateButtonDiv,
  CreateButtonImage,
  CreateButtonText,
  ErrorMessage,
  HeaderDiv,
  HeaderText,
  InputDiv,
  InputField,
  LabelCreate,
  TipText,
} from '../CreateAccessUserModal/style'
import cross from '../../assets/addStockModal/cross.svg'
import plus from '../../assets/headers/plus.svg'
import ModalContext from '../../contexts/ModalContext'
import axios from '../../config/axios'
import { FeedbackContext } from '../../contexts/FeedbackContext'

interface EditTenantModalProps {
  tenantId: number
  onUpdate: () => void
}

const EditTenantModal: React.FC<EditTenantModalProps> = ({ tenantId, onUpdate }) => {
  const [formData, setFormData] = useState({
    companyName: '',
    segment: '',
    cnpj: '',
  })
  const { setModalActive } = useContext(ModalContext)
  const { setFeedback } = useContext(FeedbackContext)
  const [error, setError] = useState('')
  const [click, setClick] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchTenantData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/tenant/${tenantId}`)
        
        if (response.data) {
          setFormData({
            companyName: response.data.companyName || '',
            segment: response.data.segment || '',
            cnpj: response.data.cnpj || '',
          })
        }
      } catch (error) {
        console.error('Erro ao buscar dados do tenant:', error)
        setError('Erro ao carregar dados do tenant')
      } finally {
        setLoading(false)
      }
    }

    fetchTenantData()
  }, [tenantId])

  const validateForm = () => {
    if (!formData.companyName || formData.companyName.length < 3) return false
    if (!formData.segment || formData.segment.length < 2) return false
    if (!formData.cnpj || formData.cnpj.length < 14) return false
    return true
  }

  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }))
    setError('')
  }

  const updateTenant = async () => {
    if (!validateForm()) {
      setClick(true)
      return
    }

    try {
      await axios.patch(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/tenant/${tenantId}`, formData)
      setFeedback({
        isOpen: true,
        message: 'Tenant atualizado com sucesso',
        statusOk: true
      })
      setModalActive(false)
      onUpdate()
    } catch (error: any) {
      console.error('Erro ao atualizar tenant:', error)
      if (error.response?.status === 409) {
        setError('Tenant com este CNPJ já existe')
      } else if (error.response?.status === 400) {
        const messages = error.response?.data?.message
        if (Array.isArray(messages)) {
          setError(messages.join(', '))
        } else {
          setError('Dados inválidos. Verifique os campos obrigatórios.')
        }
      } else {
        setError('Erro ao atualizar tenant')
      }
      setFeedback({
        isOpen: true,
        message: error.response?.data?.message || 'Erro ao atualizar tenant',
        statusOk: false
      })
    }
  }

  const isValid = validateForm()

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Editar tenant</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>

      {loading && <p>Carregando dados...</p>}
      {error && <ErrorMessage>{error}</ErrorMessage>}

      <InputDiv>
        <LabelCreate>Nome da empresa *</LabelCreate>
        <InputField
          placeholder='Digite o nome da empresa'
          type='text'
          value={formData.companyName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('companyName', e.target.value)}
        />
      </InputDiv>

      <InputDiv>
        <LabelCreate>Segmento *</LabelCreate>
        <InputField
          placeholder='Digite o segmento (ex: Aco, fashion)'
          type='text'
          value={formData.segment}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('segment', e.target.value)}
        />
      </InputDiv>

      <InputDiv>
        <LabelCreate>CNPJ *</LabelCreate>
        <InputField
          placeholder='Digite o CNPJ (apenas números)'
          type='text'
          value={formData.cnpj}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('cnpj', e.target.value.replace(/\D/g, ''))}
        />
      </InputDiv>

      <ButtonsDiv>
        {!isValid && click && (
          <TipText>Preencha todos os campos obrigatórios corretamente</TipText>
        )}
        <CreateButtonDiv onClick={updateTenant}>
          <CreateButtonImage src={plus} alt='Plus icon' />
          <CreateButtonText>Atualizar tenant</CreateButtonText>
        </CreateButtonDiv>
      </ButtonsDiv>
    </Container>
  )
}

export default EditTenantModal
